import { Injectable, computed } from '@angular/core';

const MONTH_NAMES = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
] as const;

const MONTHS_LOOKBACK = 2;
const EARLY_MONTH_THRESHOLD = 5;

export interface MonthInfo {
  name: string;
  year: number;
  monthIndex: number;
  full: string;
}

@Injectable({
  providedIn: 'root'
})
export class EvaluationsService {
  private readonly now = new Date();
  private readonly offset = this.now.getDate() < EARLY_MONTH_THRESHOLD ? 2 : 1;

  readonly monthsDetailed: MonthInfo[] = Array.from({ length: MONTHS_LOOKBACK }, (_, index) => {
    const date = new Date(this.now);
    date.setMonth(date.getMonth() - this.offset - index);

    return {
      name: MONTH_NAMES[date.getMonth()],
      year: date.getFullYear(),
      monthIndex: date.getMonth(),
      full: `${MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`
    };
  });

  // readonly months = this.monthsDetailed.map(m => m.name);
}
